import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../base/i18n/functions';
import { AbstractWelcomePage, _mapStateToProps } from './AbstractWelcomePage';
/**
 * The Web container rendering the welcome page.
 *
 * @augments AbstractWelcomePage
 */
class WelcomePage extends AbstractWelcomePage {
    /**
     * Default values for {@code WelcomePage} component's properties.
     *
     * @static
     */
    static defaultProps = {
        _room: ''
    };
    /**
     * Implements React's {@link Component#componentDidMount()}. Invoked
     * immediately after this component is mounted.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidMount() {
        super.componentDidMount();
        document.body.classList.add('welcome-page', 'medica-end-page');
        document.title = 'Medica \u2014 Online Consultation';
    }
    /**
     * Removes the classname used for custom styling of the welcome page.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentWillUnmount() {
        super.componentWillUnmount();
        document.body.classList.remove('welcome-page', 'medica-end-page');
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement|null}
     */
    render() {
        return (React.createElement("div", { className: 'welcome medica-end-page', id: 'welcome_page' },
            React.createElement("main", { className: 'medica-end-page__container' },
                React.createElement("div", { className: 'medica-end-page__logoWrap' },
                    React.createElement("img", { alt: 'Medica \u2014 The heartbeat of healthcare', className: 'medica-end-page__logo', src: './images/medica-logo.png' })),
                React.createElement("div", { className: 'medica-end-page__content' },
                    React.createElement("h1", { className: 'medica-end-page__title' }, "Online Consultation Platform"),
                    React.createElement("p", { className: 'medica-end-page__subtitle' }, "Thank you for using our platform. Your session has ended or you've reached this page directly."),
                    React.createElement("p", { className: 'medica-end-page__hint' }, "You may safely close this tab.")))));
    }
}
export default translate(connect(_mapStateToProps)(WelcomePage));
